import { useTranslation } from 'react-i18next';

import FullSizeTile from '../../../../shared/FullSizeTile/FullSizeTile.jsx';
import { useGetTile } from '../../../../shared/TileView/data';
import { useTileNavigation } from './hooks/useTileNavigation';
import { TileActionMenu } from '../../../../shared/TileActionMenu/TileActionMenu.jsx';
import { useScrollToStart } from '../../hooks/useScrollToStart';

export const CampaignTileView = ({ tileId, campaignId }) => {
  const { data: tile, isLoading } = useGetTile({ tileId });
  const { t } = useTranslation('tileView');
  useScrollToStart();

  const {
    isFirstTile,
    isLastTile,
    goToEdit,
    goToPreview,
    goToNext,
    goToPrevious,
    goBack,
    arrowRightRef,
    arrowLeftRef,
  } = useTileNavigation({ tile, campaignId });

  const submitAnswer = () => {
    if (isLastTile) return;

    setTimeout(() => goToNext(), 1000);
  };

  return (
    <>
      <TileActionMenu
        currentPage="tile-view"
        uuid={tileId}
        onClose={goBack}
        onClick={() => goToEdit()}
        goToEdit={goToEdit}
        goToPreview={goToPreview}
        campaignContainer={tile.campaignContainer}
        tileStatus={tile.status}
        publishDate={tile.publishDate}
        postId={tile.postId}
      >
        {t('menu.edit')}
      </TileActionMenu>
      <FullSizeTile
        tile={tile}
        loading={isLoading}
        tileOrigin="campaign"
        submitAnswer={submitAnswer}
        nextTile={goToNext}
        prevTile={goToPrevious}
        isFirstTile={isFirstTile}
        isLastTile={isLastTile}
        arrowRightRef={arrowRightRef}
        arrowLeftRef={arrowLeftRef}
      />
    </>
  );
};
